module.exports = __webpack_public_path__ + "static/LaunchDarkly_Jira-98c1cb7cd5dbd07aeaa4ce444d3d6df0.png";